import { utf16Length } from "./string-validation"
import { z } from "zod"

export const FulfillmentResumeChoiceSchema = z.discriminatedUnion("choice", [
	z.object({ choice: z.literal("collect_now"), cycleId: z.uuid() }),
	z.object({ choice: z.literal("next_scheduled") }),
	z.object({ choice: z.literal("future_date"), paymentDate: z.iso.date() }),
])
export type FulfillmentResumeChoice = z.infer<typeof FulfillmentResumeChoiceSchema>
export const FulfillmentResumeRequestSchema = z.object({
	selection: FulfillmentResumeChoiceSchema,
	reason: z.string().trim().min(1).apply(utf16Length("max", 2000)),
	previewToken: z.string().min(1).optional(),
})
export const FulfillmentResumePreviewSchema = z.object({
	previewToken: z.string(),
	selection: FulfillmentResumeChoiceSchema,
	selectedCycleIndex: z.number().int().positive(),
	selectedCycleId: z.uuid().nullable(),
	amountCents: z.number().int().nonnegative(),
	currency: z.string(),
	paymentDate: z.iso.date(),
	nextPaymentDate: z.iso.date().nullable(),
	nextAmountCents: z.number().int().nonnegative().nullable(),
	skippedCycleIndexes: z.array(z.number().int().positive()),
	collectNowAvailable: z.boolean(),
})
export type FulfillmentResumePreview = z.infer<typeof FulfillmentResumePreviewSchema>
